import React from "react";
import PropTypes from "prop-types";
import Button from "material-ui/Button";
import Table from "material-ui/Table";
import TBody from "material-ui/Table/TableBody";
import Thead from "material-ui/Table/TableHead";
import Tc from "material-ui/Table/TableCell";
import Tr from "material-ui/Table/TableRow";
import Paper from "material-ui/Paper";
import Input from "uis/CInput";
import { isAdmin } from "utils/formatter";

const styleTable = {
  head: {
    backgroundColor: "rgba(63, 81, 181, 0.7)",
    color: "#E8EAF6",
    fontWeight: "bold",
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: "center"
  },
  odd: {
    backgroundColor: "rgba(197, 202, 233, 0.7)"
  },
  even: {
    backgroundColor: "rgba(159, 168, 218, 0.7)"
  }
};

const tcStyle = {
  paddingLeft: 10,
  paddingRight: 10
};

const inputStyle = {
  margin: 0,
  padding: 0
};

const makeTBody = (v, changeEditable, changeAnswer, updateAnswer, deleteAnswer, i) => (
  <Tr key={`pros-${i}`} style={i % 2 === 0 ? styleTable.even : styleTable.odd}>
    <Tc style={{ ...tcStyle, textAlign: "right" }}>{v.number}</Tc>
    <Tc style={{ ...tcStyle, textAlign: "center" }}>{v.attr}</Tc>
    <Tc style={tcStyle}>
      {v.isEdit ? (
        <Input
          id={`answer-${v.id}`}
          inputProps={{
          "aria-label": "Description"
        }}
          value={v.answer || ""}
          rowsMax="5"
          fullWidth
          multiline
          style={inputStyle}
          onChange={e => changeAnswer(v.id, e.target.value)}
        />
    ) : (
      <span>{v.initAnswer}</span>
    )}
    </Tc>
    {isAdmin() && (
    <Tc style={tcStyle}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          textAlign: "center",
          minHeight: 85,
          minWidth: 90
        }}
      >
        <Button
          style={{ color: "red" }}
          onClick={() => deleteAnswer(v.id)}
        >
          削除
        </Button>
        {v.isEdit ? (
          <div style={{ flexDirection: "column" }}>
            <Button dense onClick={() => changeEditable(v.id, !v.isEdit)}>
              キャンセル
            </Button>
            <Button
              dense
              raised
              style={{ marginTop: 10 }}
              onClick={() => updateAnswer(v.id, v.answer)}
            >
              更新
            </Button>
          </div>
        ) : (
          <Button onClick={() => changeEditable(v.id, !v.isEdit)}>
            編集
          </Button>
        )}
      </div>
    </Tc>
  )}
  </Tr>
);

const FreeOpinionTable = props => (
  <div style={{ display: "inline-block", width: "100%" }}>
    <Paper>
      <Table>
        <Thead>
          <Tr>
            <Tc style={{ ...styleTable.head, width: 40 }}>No.</Tc>
            <Tc style={{ ...styleTable.head, width: 200 }}>
              {props.attrTitle}
            </Tc>
            <Tc style={styleTable.head}>自由記入</Tc>
            {isAdmin() && <Tc style={{ ...styleTable.head, width: 40 }} />}
          </Tr>
        </Thead>
        <TBody>
          {props.data.map((v, i) =>
            makeTBody(
              v,
              props.changeEditable,
              props.changeAnswer,
              props.updateAnswer,
              props.deleteAnswer,
              i
            )
          )}
        </TBody>
      </Table>
    </Paper>
  </div>
);

FreeOpinionTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  attrTitle: PropTypes.string.isRequired,
  changeEditable: PropTypes.func.isRequired,
  changeAnswer: PropTypes.func.isRequired,
  updateAnswer: PropTypes.func.isRequired,
  deleteAnswer: PropTypes.func.isRequired
};

export default FreeOpinionTable;



// WEBPACK FOOTER //
// ./src/components/ReportDetail/FreeOpinionTable.jsx